// trampoline-root.component.ts
import { Component } from '@angular/core';

@Component({
	selector: 'app-trampoline-root',
	template: '<router-outlet></router-outlet>',
})
export class TrampolineRootComponent {}
